// extracted by mini-css-extract-plugin
module.exports = {"grid":"blog_grid__iAi9O","articleSection":"blog_articleSection__HfoqI","post":"blog_post__0JjMO"};